const en = {
  topbar: {
    title: 'Seamless By Save Your Wardrobe',
    logout: 'Log Out'
  },
  common: {
    email: 'Email',
    submit: 'Submit',
    continue: 'Continue',
    cancel: 'Cancel',
    back: 'Back',
    next: 'Next',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    confirm: 'Confirm',
    close: 'Close',
    search: 'Search',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    noData: 'No data available',
    notFound: 'Not found',
    'Back to Dashboard': 'Back to Dashboard'
  },
  login: {
    clickLoginBtn: 'Click to login',
    loginError: 'Login failed, please try again.'
  },
  ResetPasswordForm: {
    wantLoginPage: 'Want to login?',
    login: 'Log in'
  },
  booking: {
    nextStepBtnLabel: 'Continue',
    prevStepBtnLabel: 'Back to Dashboard'
  },
  uploadImages: {
    title: 'Upload photos',
    subtitle:
      'You will be able to add a total of 4 images of your item, showing the full item as well as the issue area.',
    uplaodButton: 'Tap here to add photo',
    maximumNumber: 'Maximum number of photos reached',
    continueButton: 'Continue',
    cancelButton: 'Cancel',
    editButton: 'Edit Photos'
  },
  landing: {
    'Brands asked, we delivered. Introducing the':
      'Brands asked, we delivered. Introducing the',
    'Aftersales Diagnostic Tool': 'Aftersales Diagnostic Tool ',
    'by Save Your Wardrobe.': 'by Save Your Wardrobe.',
    'Click below to receive a personalised aftersales business case for your business':
      'Click below to receive a personalised aftersales business case for your business',
    'Start assessment': 'Start assessment'
  },
  itemDetails: {
    'What item needs some love?': 'What item needs some love?',
    'Item details': 'Item details',
    'What category best describes the item?':
      'What category best describes the item?'
  },
  services: {
    'select a service': 'Select a service',
    'select the one that best applies': 'Select the one that best applies'
  },
  businessCase: {
    title: 'The Business Case',
    description:
      'See below the projected financial benefits from implementing your recommended aftersales solution. You may edit your inputs to view a live simulation of how the projections would change.',
    summary: 'Summary',
    customerLifetimeValue: 'Customer Lifetime Value',
    ROI: 'Return on Investment',
    region: 'Region',
    estimatedCosts: 'Estimated Costs',
    estimatedSavings: 'Estimated Savings',
    brandInputs: 'Brand Inputs',
    totalSavings: 'Total Gross Revenue/Savings'
  },
  solution: {
    buisnessCase: 'The business case',
    solution: 'The solution',
    benefit: 'would benefit from',
    capture: 'You could capture over',
    saving: 'in revenue/savings by implementing this solution'
  },
  loading: {
    finalisingBusinessCase:
      "Please wait while we finalise {{brandName}}'s Business Case"
  }
};

export default en;
